import css from 'styled-jsx/css';

const styles = css.global`#seguro-auto-portal-app {
    background: #DEEDF2;
}


#seguro-auto-portal-app .portal-app-card {
    padding-top: 24px;
}

#seguro-auto-portal-app .portal-app-card.portal-card {
    padding-bottom: 44px;
}

#seguro-auto-portal-app .portal-app-card.app-card {
    padding-bottom: 33px;
}

#seguro-auto-portal-app .portal-app-card picture {
    width: 100%;
}

#seguro-auto-portal-app .portal-app-card picture img {
    width: 100%;
    height: 189px;
    object-fit: cover;
    object-position: top;
    border-radius: 4px;
}

#seguro-auto-portal-app .portal-app-card-titulo {
    margin-top: 11px;
    color: #444;
    font-family: "SantanderHeadline";
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 36px;
}

#seguro-auto-portal-app .portal-app-card-texto {
    margin-top: 8px;
    color:#444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
}

#seguro-auto-portal-app .portal-app-card-link {
    margin-top: 16px;
    display: inline-block;
    color: #C00;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px; 
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
}

#seguro-auto-portal-app .portal-app-card-lojas {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: center;
    justify-content: center;
}

@media (min-width: 992px) {
    #seguro-auto-portal-app {
        padding: 88px 0 66px;
    }

    #seguro-auto-portal-app .ctn-home-24 {
        display: flex;
        gap: 15px;
        justify-content: space-between;
    }

    #seguro-auto-portal-app .portal-app-card {
        padding: 0;
        max-width: 500px;
        width: 100%;
        overflow: hidden;
    }

    #seguro-auto-portal-app .portal-app-card.portal-card,
    #seguro-auto-portal-app .portal-app-card.app-card {
        padding-bottom: 0;
    }

    #seguro-auto-portal-app .portal-app-card picture img {
        height: 303px;
    }

    #seguro-auto-portal-app .portal-app-card-titulo {
        margin-top: 32px;
        font-size: 32px;
        line-height: 48px;
    }

    #seguro-auto-portal-app .portal-app-card.app-card .portal-app-card-titulo {
        width: 500px;
    }
    
    #seguro-auto-portal-app .portal-app-card-texto {
        margin-top: 16px;
    }
    
    #seguro-auto-portal-app .portal-app-card-link {
        margin-top: 47px;
    }
    
    #seguro-auto-portal-app .portal-app-card-lojas {
        margin-top: 24px;
        flex-direction: row;
        gap: 24px;
        justify-content: flex-start;
    }
}`;

export default styles;